import {
  EVALUATION_DATA_SUCCESS,
  GET_FOOTER_DATE,
  IS_LOADING,
  MEDICAL_RECORD_DATA_SUCCESS,
  QUICKFILTER_DATA_SUCCESS,
  EVALUATION_ADJUSTMENT_DATA_SUCCESS,
  KNOWLEDGE_CENTRE_DATA_SUCCESS,
  GLOSSARY_LIST_DATA,
  SELECTED_RADIO_OPTIONS,
  EVALUATION_DETAILS_DATA_SUCCESS,
  EVALUATION_DATA_LOADING,
  EVALUATION_ADJUSTMENT_DATA_LOADING,
  MEDICAL_RECORD_DATA_LOADING,
  REASON_CODE_DATA_LOADING,
  OVERTURNS_DATA_SUCCESS,
  OVERTURNS_DATA_LOADING,
  INIT_PI_FILTERS,
  UPDATE_PI_FILTERS,
  RESET_PI_FILTERS,
  SET_PI_GEO_VENDOR_OPTIONS,
  SET_PI_PROVIDER_SIGNATURE

} from '../../../actions/actionTypes';
import { savePIFiltersToSession } from '@src/apps/Reimbursement/PaymentIntegrity/PIGlobalFilters/services/piFilterStateManager';

interface PIFiltersState {
  timePeriod: any;
  taxId: any[];
  contractIds: string[];
  lineOfBusiness: string;
  claimType: string;
  serviceType: string;
  vendor: string;
}

interface PaymentIntegrityState {
  evaluationData: any;
  evaluationDataLoading: boolean;
  timePeriod: any;
  isLoading: boolean;
  medicalRecordData: any;
  medicalRecordLoading: boolean;
  quickFilterTinData: any;
  getEvaluationsAdjustmentData: any;
  getEvaluationsAdjustmentDataLoading: any;
  metricData:any;
  glossaryList:any;
  evaluationDetailsData:any;
  selectedRadioValue:any;
  reasonCodeTableDataLoading: boolean;
  overturnsData: any;
  overturnsDataLoading: boolean;
  piFilters: PIFiltersState;
  geoVendorOptions: Array<{ label: string; value: string }>;
  providerSignature: string;
}

const defaultPIFilters: PIFiltersState = {
  timePeriod: null,
  taxId: [],
  contractIds: [],
  lineOfBusiness: 'All',
  claimType: 'All',
  serviceType: 'All',
  vendor: 'All',
};

const initialState: PaymentIntegrityState = {
  evaluationData: {},
  isLoading: true,
  evaluationDataLoading: true,
  timePeriod: "",
  medicalRecordData: {},
  medicalRecordLoading: true,
  quickFilterTinData: {},
  getEvaluationsAdjustmentData: {},
  getEvaluationsAdjustmentDataLoading: true,
  metricData:{},
glossaryList:{},
selectedRadioValue:{},
evaluationDetailsData:{},
reasonCodeTableDataLoading: true,
overturnsData: null,
overturnsDataLoading: true,
piFilters: defaultPIFilters,
geoVendorOptions: [],
providerSignature: ''
};

const PaymentIntegrityReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentIntegrityState => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case EVALUATION_DATA_SUCCESS:
      return {
        ...state,
        evaluationData: action.payload,
      };

    case GET_FOOTER_DATE:
      return {
        ...state,
        timePeriod: action.payload,
      };

    case MEDICAL_RECORD_DATA_SUCCESS:
      return {
        ...state,
        medicalRecordData: action.payload,
      };

      case QUICKFILTER_DATA_SUCCESS:
        return {
          ...state,
          quickFilterTinData: action.payload,
        };
    case EVALUATION_ADJUSTMENT_DATA_SUCCESS:
      return {
        ...state,
        getEvaluationsAdjustmentData: action.payload,
      };

      case OVERTURNS_DATA_SUCCESS:
      return {
        ...state,
        overturnsData: action.payload,
      };

      case KNOWLEDGE_CENTRE_DATA_SUCCESS:
      return {
        ...state,
        metricData: action.payload,

      };
      case GLOSSARY_LIST_DATA:
        return {
          ...state,
          glossaryList: action.payload,

        };

        case EVALUATION_DETAILS_DATA_SUCCESS:
          return {

            ...state,
            evaluationDetailsData: action.payload,
          };
        case SELECTED_RADIO_OPTIONS:
        return {
          ...state,
          selectedRadioValue: action.payload,
        }
        case EVALUATION_DATA_LOADING:
          return {
            ...state,
            evaluationDataLoading: action.payload
          }

           case EVALUATION_ADJUSTMENT_DATA_LOADING:
          return {
            ...state,
            getEvaluationsAdjustmentDataLoading: action.payload
          }
           case MEDICAL_RECORD_DATA_LOADING:
          return {
            ...state,
            medicalRecordLoading: action.payload
          }

          case OVERTURNS_DATA_LOADING:
          return {
            ...state,
            overturnsDataLoading: action.payload
          }

          case REASON_CODE_DATA_LOADING:
            return {
            ...state,
            reasonCodeTableDataLoading: action.payload
          }

          case INIT_PI_FILTERS: {
            const filters = { ...defaultPIFilters, ...action.payload };
            savePIFiltersToSession(filters);
            return { ...state, piFilters: filters };
          }

          case UPDATE_PI_FILTERS: {
            const updated = { ...state.piFilters, ...action.payload };
            savePIFiltersToSession(updated);
            return { ...state, piFilters: updated };
          }

          case RESET_PI_FILTERS: {
            const resetFilters = { ...defaultPIFilters, ...action.payload };
            savePIFiltersToSession(resetFilters);
            return { ...state, piFilters: resetFilters };
          }

          case SET_PI_GEO_VENDOR_OPTIONS:
            return {
              ...state,
              geoVendorOptions: Array.isArray(action.payload) ? action.payload : [],
            };

          case SET_PI_PROVIDER_SIGNATURE:
            return {
              ...state,
              providerSignature: typeof action.payload === 'string' ? action.payload : '',
            };


    default:
      return state;
  }
};

export default PaymentIntegrityReducer;
